export default __webpack_public_path__ + "static/media/dialdelete.9bf5461a.svg";